import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { FullWidthContainer } from "~/components/FullWidthContainer";
import { Page } from "~/components/Page";
import { IngestionPartTable } from "./components/IngestionPartTable";

export function IngestionPartsPage() {
  return (
    <Page title="Search Ingestion Parts">
      <FullWidthContainer>
        <DataStoreBreadcrumbs />
        <IngestionPartTable />
      </FullWidthContainer>
    </Page>
  );
}
